import React from "react";
import { Button, Col, Row, Container } from "reactstrap";
import { Link as ScrollLink } from 'react-scroll';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';

import SubscribeNewsletter from "components/Forms/SubscribeNewsletter";

const MainFooter = () => {

  // const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:3001';
  const apiUrl = process.env.REACT_APP_API_URL;

  const blueIconStyle = { color: '#02223A' }; // Hex color for blue

  return (
    <footer className="footer footer-black footer-white d-flex align-items-center">
      <Container>
        <Row className="justify-content-center align-items-center text-center flex-wrap">
          <Col sm="auto" md="6" lg="auto" className="mt-3">
            {/* <SubscribeNewsletter serverEndpoint='http://localhost:3001/subscribe' /> */}
            <SubscribeNewsletter serverEndpoint={`${apiUrl}/subscribe`} />
          </Col>
          <Col sm="auto" md="3" lg="auto" className="mt-3">
            <nav className="footer-nav">
              <ul className="d-flex align-items-center justify-content-center">
                <li style={{margin: 0}}>
                  <a
                    href="https://www.linkedin.com/company/maglev-aero/mycompany/"
                    target="_blank"
                    aria-label="Visit our LinkedIn page"
                    style={{fontSize: "1.1em"}}
                  >
                    <i className="fa fa-linkedin" style={blueIconStyle}/>
                    <p className="d-md-none" style={blueIconStyle}>LinkedIn</p>
                  </a>
                </li>
                <li style={{margin: 0}}>
                  <a
                    href="https://www.instagram.com/maglevaero/"
                    target="_blank"
                    aria-label="Visit our Instagram page"
                    style={{fontSize: "1.1em"}}
                  >
                    <i className="fa fa-instagram" style={blueIconStyle} />
                    <p className="d-md-none"style={blueIconStyle} >Instagram</p>
                  </a>
                </li>
                <li style={{margin: 0}}>
                  <a
                    href="mailto:contact@maglevaero.com"
                    target="_blank"
                    aria-label="Send us an email"
                    style={{fontSize: "1.1em"}}
                  >
                    <i className="fa fa-envelope" style={blueIconStyle}/>
                    <p className="d-md-none" style={ blueIconStyle }>Email</p>
                  </a>
                </li>
              </ul>
            </nav>
          </Col>
          <Col sm="auto" md="6" lg="auto" className="mt-3">
            <Button style={{backgroundColor: "transparent", border:"none"}} >
              <ScrollLink
                className ='nav-link'
                to="Home" // Replace with the name of your contact section Element
                spy={true}
                smooth={true}
                offset={-70} // Adjust the offset if necessary
                duration={500} // Duration of the scroll animation
                style={{fontWeight: 'normal', color:'#02223A'}}
              >
                Back to top
              </ScrollLink>
              <noscript>
                <a href="#Home" style={{ textDecoration: 'none', color: '#02223A' }}>
                  Back to top
                </a>
              </noscript>
            </Button>
          </Col>
          <Col sm="auto" md="6" lg="auto" className="mt-3">
            <Link to="/privacy-policy" target="_blank" style={{ textDecoration: 'none' }}>
              <Button style={{backgroundColor: "transparent", border:"none", fontWeight: 'normal', color:'#02223A'}} >
                Privacy Policy&nbsp;&nbsp;<FontAwesomeIcon icon={faExternalLink}/>
              </Button>
            </Link>
          </Col>
          <Col sm="auto" md="6" lg="auto" className="mt-2">
            <span style={blueIconStyle}>&copy; {new Date().getFullYear()} MagLev Aero. All rights reserved.</span>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default MainFooter;
